import { type } from 'jquery';
import types from '../types';
import { ActionOpacity } from 'material-ui/svg-icons';

const initialState = {
  jwtAccessToken: '',
  inventoryList: {},
  seriesList: {},
  roNameList: {},
  allocateData: {},
  view_series_inventry_list: {},
  auditLogList: false,
};

const inventoryList = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_USER_JWT:
      return {
        ...state,
        jwtAccessToken: action.payload,
      };
    case types.RESET_CONFIGURATOR_STATE:
      return {
        ...initialState,
      };
    case types.SET_INVENTORY_DATA:
      const { inventoryList } = action.payload;
      return {
        ...state,
        inventoryList,
      };
    case types.SET_HO_INVENTORY_DATA:
      const { HO_RO_InventoryList } = action.payload;
      return {
        ...state,
        HO_RO_InventoryList,
      };
    case types.SET_RO_INVENTORY_LABEL_ALLOCATION_DATA:
      const { RO_LabelAllocation_InventoryList } = action.payload;
      return {
        ...state,
        RO_LabelAllocation_InventoryList,
      };
    case types.SET_DASHBOARD_DATA:
      const { downloadHoData } = action.payload;
      return {
        ...state,
        downloadHoData,
      };
    case types.SET_HO_ASSIGN_TO_RO:
      const { assignToRo } = action.payload;
      return {
        ...state,
        assignToRo,
      };
    case types.SET_TEXTILE_SERIES:
      const { seriesList } = action.payload;
      return {
        ...state,
        seriesList,
      };
    case types.SET_RO_NAME_LIST:
      const { roNameList } = action.payload;
      return {
        ...state,
        roNameList,
      };
    
      case types.SET_GET_RO_SERIES:
        const { getROSeries } = action.payload;
        return {
          ...state,
          getROSeries,
        }; 
    case types.SET_ALLOCATE_DATA:
      const { allocateData } = action.payload;
      return {
        ...state,
        allocateData,
      };
    case types.SET_VIEW_SERIES_INVENTRY_LIST:
      const { view_series_inventry_list } = action.payload;
      return {
        ...state,
        view_series_inventry_list,
      }
    case types.SET_RO_TO_RO_LABEL_TRANSFER:
      const { ro_to_ro_label_transfer } = action.payload;
      return {
        ...state,
        ro_to_ro_label_transfer,
      }
    case types.SET_RO_LABEL_REQUEST:
      const { roLabelRequest } = action.payload;
      return {
        ...state,
        roLabelRequest,
      }
    case types.SET_ROLE_LIST_DELIVERY_REMARK:
      const { roDeliveryStatus } = action.payload;
      return {
        ...state,
        roDeliveryStatus,
    }
    case types.SET_HO_DELIVERY_STATUS:
      const { ho_delivery_status } = action.payload;
      return {
        ...state,
        ho_delivery_status,
      }
    case types.HO_REPRINT_SERIES_LABEL:
      const { reprint_series_label } = action.payload;
      return {
        ...state,
        reprint_series_label,
      }
      case types.SET_SAVE_PRINT_LABEL:
        const {save_print_label} = action.payload;
        return{
          ...state,
          save_print_label,
        }
    case types.SET_AUDITLOG_DATA:
      const { auditLogList } = action.payload;
      return {
        ...state,
        auditLogList,
      };
    case types.SET_ASSIGN_LIST:
      const { assign_label } = action.payload;
      return {
        ...state,
        assign_label,
      };
      case types.SET_DOWNLOAD_REPRINT:
        const {reprint_download } = action.payload;
        return {
          ...state,
          reprint_download,
      };
      case types.SET_UPDATE_REPRINT:
        const {reprint_update} = action.payload;
        return {
          ...state,
          reprint_update,
      };
    case types.RESET_WORKLIST_DATA:
      return {
        ...state,
        workLists: false,
      };

      
    default:
      return state;
  }
};

export default inventoryList;
